// ---------------------------------------------------------------------------
// SchoolContext — the selected school's identity + controller health strip.
// ---------------------------------------------------------------------------
import React from "react";

function SchoolContext({school, i18n}) {
    const {t, num, lang} = i18n;
    const d = school.device || {};
    const sync = d.last_seen ? new Date(d.last_seen) : null;
    const mins = sync ? Math.max(0, Math.round((Date.now() - sync) / 60000)) : null;
    const lastSync =
        mins === null ? "—" : mins < 1 ? t("justNow") : num(mins) + t("minAgo");

    const meta = [
        {
            k: "device",
            v: (
                <>
                    <span className={`dot ${d.online ? "ok pulse" : "bad"}`} /> {d.id || "—"}
                </>
            ),
        },
        {k: "lastSync", v: lastSync},
        {k: "zones", v: num((school.zones || []).length)},
        {k: "students", v: school.students ? num(school.students) : "—"},
    ];

    return (
        <section className="context">
            <div>
                <div className="ctx-name">{lang === "ne" && school.name_ne ? school.name_ne : school.name}</div>
                <div className="ctx-sub">
                    <span className="chip">{school.code}</span>
                    {school.type ? <span className="chip mut">{school.type}</span> : null}
                    <span>{school.address || school.district || ""}</span>
                </div>
            </div>
            <div className="ctx-meta">
                {meta.map((m) => (
                    <div key={m.k}>
                        <div className="meta-k">{t(m.k)}</div>
                        <div className="meta-v">{m.v}</div>
                    </div>
                ))}
            </div>
        </section>
    );
}

export default SchoolContext;
